import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_SEATS = "getPaginatedSeats";
export const ALL_SEATS = "getAllSeats";
export const CREATE_SEAT_FORM = "createSeatForm";
export const DELETE_SEAT = "deleteSeat";
export const GET_SEAT_DATA = "getSeatData";
export const CREATE_SEAT = "createSeat";
export const UPDATE_SEAT = "updateSeat";
export const ALL_SEATS_EXCEPT_CHOOSEN = "getAllSeatsExceptChoosen";


// mutation types

export const SET_PAGINATED_SEATS = "setPaginatedSeats";
export const SET_ALL_SEATS = "setAllSeats";
export const SET_SEAT_DATA = "setSeatData";
export const SET_SEAT_META = "setSeatMeta";
export const SET_SEAT_ERROR = "setSeatError";
export const SET_SEAT_LOADING = "setSeatLoading";
export const CLEAR_SEAT_ERROR = "clearSeatError";
export const SET_IS_DISABLED_SEAT = "setIsDisabledSeat";


const state = {
    seats: [],
    paginatedSeats: [],
    seat_data: {},
    meta_seat : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllSeats(state) {
        return state.paginatedSeats;
    },

    allSeats(state) {
        return state.seats;
    },

    getSeatData(state) {
        return state.seat_data;
    },

    meta_seat(state) {
        return state.meta_seat;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_SEATS](context, payload) {
        context.commit(SET_IS_DISABLED_SEAT, false);
        context.commit(SET_SEAT_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/seats?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_SEAT_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_SEATS, data);
                context.commit(SET_SEAT_META, data);
                context.commit(SET_SEAT_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_SEAT_LOADING, false);
            context.commit(SET_SEAT_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_SEATS]() {
        return new Promise(resolve => {
            ApiService.get('/seatsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [ALL_SEATS_EXCEPT_CHOOSEN](context, payload) {
        context.commit(SET_SEAT_LOADING, true);
        return new Promise(resolve => {
            let url = `/seatsAllExceptChoosen/${payload.match_id}`;
            
            // Check if `selected_seat_id` is provided and append it to the URL
            if (payload.selected_seat_id) {
                url += `/${payload.selected_seat_id}`;
            }
    
            ApiService.get(url)
                .then((response) => {
                    resolve(response);
                    context.commit(SET_SEAT_LOADING, false);
                })
                .catch(() => {
                    context.commit(SET_SEAT_LOADING, false); // Make sure loading is disabled on error too
                });
        });
    },

    [CREATE_SEAT_FORM](context) {
        context.commit(SET_SEAT_LOADING, false);
        context.commit(SET_SEAT_ERROR, false);
        context.commit(SET_IS_DISABLED_SEAT, false);
    },

    [GET_SEAT_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_SEAT, true);
        context.commit(SET_SEAT_LOADING, true);
        context.commit(CLEAR_SEAT_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/seat/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_SEAT_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_SEAT_DATA, response.data);
                    context.commit(SET_SEAT_LOADING, false);
                    context.commit(SET_IS_DISABLED_SEAT, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_SEAT_LOADING, false);
                context.commit(SET_SEAT_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_SEAT, true);
            });
        });
    },

    [CREATE_SEAT](context, payload) {
        context.commit(SET_SEAT_LOADING, false);
        context.commit(SET_IS_DISABLED_SEAT, true);
        context.commit(CLEAR_SEAT_ERROR);
        return ApiService.post("/seat/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_SEAT_ERROR);
            }
            else{
                context.commit(SET_SEAT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Koltuk başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_SEAT_ERROR);
                context.commit(SET_IS_DISABLED_SEAT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_SEAT_LOADING, false);
            context.commit(SET_SEAT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_SEAT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_SEAT](context, payload) {
        context.commit(SET_SEAT_LOADING, true);
        context.commit(SET_IS_DISABLED_SEAT, true);
        context.commit(CLEAR_SEAT_ERROR);
        
        return ApiService.put(`/seat/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_SEAT_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı koltuk başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_SEAT, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_SEAT_LOADING, false);
            context.commit(SET_SEAT_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_SEAT, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_SEAT](context, payload) {
        context.commit(SET_SEAT_LOADING, true);
        context.commit(CLEAR_SEAT_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/seat/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_SEAT_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı koltuk başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_SEAT_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_SEATS](state, paginatedSeats) {
        state.paginatedSeats = paginatedSeats.data;
    },

    [SET_ALL_SEATS](state, seats) {
        state.seats = seats;
    },

    [SET_SEAT_DATA](state, seats_data) {
        state.seats_data = seats_data;
        state.errors = [];
    },

    [SET_SEAT_META](state, meta_seat) {
        state.meta_seat = meta_seat;
    },

    [SET_SEAT_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_SEAT_ERROR](state) {
        state.errors = [];
    },
    
    [SET_SEAT_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_SEAT](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
